<template>
    <section id="sign-up-section" class="row sign-up-form">
        <div class="container">
            <div class="row">
                <div class="col-xs-12">
                    <h1>SIGN UP</h1>
                    <form @submit.prevent="validateForm">
                        <div class="row">
                            <div class="col-xs-12 col-sm-6">
                                <div class="form-group">
                                    <input
                                        id="first-name"
                                        v-model.trim="firstName"
                                        v-validate="'required|max:255'"
                                        data-vv-validate-on="change"
                                        data-vv-as="first name"
                                        type="text"
                                        :class="{'border-danger': errors.has('first-name')}"
                                        class="form-control"
                                        name="first-name"
                                        placeholder="FIRST NAME">
                                    <span v-show="errors.has('first-name')" class="text-danger text-uppercase">{{ errors.first('first-name') }}</span>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-6">
                                <div class="form-group">
                                    <input
                                        id="last-name"
                                        v-model.trim="lastName"
                                        v-validate="'required|max:255'"
                                        data-vv-validate-on="change"
                                        data-vv-as="last name"
                                        type="text"
                                        :class="{'border-danger': errors.has('last-name')}"
                                        class="form-control"
                                        name="last-name"
                                        placeholder="LAST NAME">
                                    <span v-show="errors.has('last-name')" class="text-danger text-uppercase">{{ errors.first('last-name') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12">
                                <div class="form-group">
                                    <input
                                        id="address-line-1"
                                        v-model.trim="addressLine1"
                                        v-validate="'required|max:255'"
                                        data-vv-validate-on="change"
                                        data-vv-as="address line 1"
                                        type="text"
                                        :class="{'border-danger': errors.has('address-line-1')}"
                                        class="form-control"
                                        name="address-line-1"
                                        placeholder="ADDRESS LINE 1">
                                    <span v-show="errors.has('address-line-1')" class="text-danger text-uppercase">{{ errors.first('address-line-1') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12">
                                <div class="form-group">
                                    <input
                                        id="address-line-2"
                                        v-model.trim="addressLine2"
                                        type="text"
                                        class="form-control"
                                        name="address-line-2"
                                        placeholder="ADDRESS LINE 2">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 col-sm-6">
                                <div class="form-group">
                                    <input
                                        id="city"
                                        v-model.trim="city"
                                        v-validate="'required|max:255'"
                                        data-vv-validate-on="change"
                                        data-vv-as="city"
                                        type="text"
                                        :class="{'border-danger': errors.has('city')}"
                                        class="form-control"
                                        name="city"
                                        placeholder="CITY">
                                    <span v-show="errors.has('city')" class="text-danger text-uppercase">{{ errors.first('city') }}</span>
                                </div>
                            </div>
                            <div class="col-xs-4 col-sm-2">
                                <div id="state-multiselect-container" class="form-group">
                                    <multiselect
                                        id="state"
                                        v-model.trim="state"
                                        v-validate="'required|max:255'"
                                        data-vv-validate-on="change"
                                        data-vv-as="state"
                                        name="state"
                                        :class="{'border-danger': errors.has('state')}"
                                        :allow-empty="false"
                                        :options="statesList"
                                        :searchable="false"
                                        placeholder="STATE"
                                        :show-labels="false"
                                        @open="handleOpen"
                                        @close="handleClose" />
                                    <span v-show="errors.has('state')" class="text-danger text-uppercase">{{ errors.first('state') }}</span>
                                </div>
                            </div>
                            <div class="col-xs-8 col-sm-4">
                                <div class="form-group">
                                    <input
                                        id="zip-code"
                                        v-model.trim="zipCode"
                                        v-validate="'required|min:5|max:10'"
                                        title=""
                                        novalidate
                                        data-vv-validate-on="change"
                                        data-vv-as="zip code"
                                        type="text"
                                        :class="{'border-danger': errors.has('zip-code')}"
                                        class="form-control"
                                        name="zip-code"
                                        placeholder="ZIP CODE">
                                    <span v-show="errors.has('zip-code')" class="text-danger text-uppercase">{{ errors.first('zip-code') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 col-sm-6">
                                <div class="form-group">
                                    <input
                                        id="email"
                                        v-model.trim="email"
                                        v-validate="'email|required|max:255'"
                                        data-vv-validate-on="change"
                                        data-vv-as="email"
                                        type="email"
                                        :class="{'border-danger': errors.has('email')}"
                                        class="form-control"
                                        name="email"
                                        placeholder="EMAIL">
                                    <span v-show="errors.has('email')" class="text-danger text-uppercase">{{ errors.first('email') }}</span>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-6">
                                <div class="form-group">
                                    <input
                                        id="phone-number"
                                        v-model.trim="phoneNumber"
                                        v-validate="'required|max:255'"
                                        data-vv-validate-on="change"
                                        data-vv-as="phone number"
                                        type="text"
                                        :class="{'border-danger': errors.has('phone-number')}"
                                        class="form-control"
                                        name="phone-number"
                                        placeholder="PHONE NUMBER">
                                    <span v-show="errors.has('phone-number')" class="text-danger text-uppercase">{{ errors.first('phone-number') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12">
                                <div id="intended-use-multiselect-container" class="form-group">
                                    <multiselect
                                        id="intended-use"
                                        v-model.trim="intendedUse"
                                        v-validate="'required|max:255'"
                                        data-vv-validate-on="change"
                                        data-vv-as="intended use"
                                        name="intended-use"
                                        :allow-empty="false"
                                        :options="intendedUseList"
                                        :searchable="false"
                                        :class="{'border-danger': errors.has('intended-use')}"
                                        placeholder="INTENDED USE"
                                        :show-labels="false"
                                        @open="handleOpen"
                                        @close="handleClose" />
                                    <span v-show="errors.has('intended-use')" class="text-danger text-uppercase">{{ errors.first('intended-use') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12">
                                <div class="checkbox checkbox-purple m-b" :class="{'border-danger': errors.has('signup-privacy')}">
                                    <input
                                        id="signup-privacy"
                                        v-model.trim="signupPrivacy"
                                        v-validate="'required|max:255'"
                                        data-vv-as="signup privacy"
                                        data-vv-validate-on="change"
                                        checked
                                        name="signup-privacy"
                                        type="checkbox">
                                    <label for="signup-privacy">I ACCEPT THE PRIVACY POLICY AND OPT IN TO RECEIVE EMAILS FROM NZXT</label>
                                </div>
                                <span v-show="errors.has('signup-privacy')" class="text-danger text-uppercase">{{ errors.first('signup-privacy') }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 text-center">
                                <button class="btn btn-green m-y-md">{{ isLoading ? 'SUBMITING...' : 'SUBMIT' }}</button>
                            </div>
                        </div>
                    </form>

                    <div v-if="isLoading" class="loading">
                        <p>Submiting</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
export default {
    name: "SignUpFormSection",
    data() {
        return {
            firstName: "",
            lastName: "",
            addressLine1: "",
            addressLine2: "",
            city: "",
            state: "",
            zipCode: "",
            email: "",
            phoneNumber: "",
            plainPhoneNumber: "",
            intendedUse: "",
            signupPrivacy: true,
            statesList: [
                "AK",
                "AR",
                "AZ",
                "CA",
                "CO",
                "CT",
                "DC",
                "DE",
                "FL",
                "GA",
                "HI",
                "IA",
                "ID",
                "IL",
                "IN",
                "KS",
                "KY",
                "LA",
                "MA",
                "MD",
                "ME",
                "MI",
                "MN",
                "MO",
                "MS",
                "MT",
                "NC",
                "ND",
                "NE",
                "NH",
                "NJ",
                "NM",
                "NV",
                "NY",
                "OH",
                "OK",
                "OR",
                "PA",
                "RI",
                "SC",
                "SD",
                "TN",
                "TX",
                "UT",
                "VA",
                "VT",
                "WA",
                "WI",
                "WV",
                "WY"
            ],
            intendedUseList: [
                "SCHOOL",
                "STREAMING",
                "HOME-USE",
                "DIGITAL ART / ANIMATION",
                "WORK",
                "OTHER"
            ],
            isLoading: false
        }
    },
    created() {
        this.customizeValidationMessages();
    },
    methods: {
        customizeValidationMessages() {
            const dictionary = {
                en: {
                    custom: {
                        "signup-privacy": {
                            required: "YOU MUST ACCEPT THE PRIVACY POLICY AND OPT IN TO RECEIVE CORRESPONDENCE FROM OUR TEAM.",
                        }
                    }
                }
            };

            this.$validator.localize(dictionary);
        },
        async validateForm() {
            this.$validator.errors.clear();
            const isValid = await this.$validator.validateAll();
            const isValidPhoneNumber = this.validatePhoneNumber();
            if (!isValid || !isValidPhoneNumber) {
                return;
            }

            this.submitForm();
        },
        validatePhoneNumber() {
            try {
                const PHONE_COUNTRY_CODE = "US";
                const phoneNumber = phoneUtil.parseAndKeepRawInput(this.phoneNumber, PHONE_COUNTRY_CODE);
                const isValidPhoneNumber = phoneUtil.isValidNumberForRegion(phoneNumber, PHONE_COUNTRY_CODE);
                if (!isValidPhoneNumber) {
                    this.addPhoneNumberError();
                    return false;
                } else {
                    this.plainPhoneNumber = phoneNumber.getNationalNumber();
                    this.$validator.errors.remove({ field: "phone-number", id: "invalid-phone-number" });
                    return true;
                }
            } catch(error) {
                this.addPhoneNumberError();
                return false;
            }
        },
        addPhoneNumberError() {
            this.$validator.errors.add({
                field: 'phone-number',
                msg: 'The phone number is invalid.',
                id: 'invalid-phone-number'
            });
        },
        submitForm() {
            const signUpFormData = this.prepareSignUpFormData();

            this.isLoading = true;

            axios.post("/rental-pc/signup", signUpFormData).then(() => {
                heap.identify(this.email, "email");
                heap.track("Rental PC: Signed Up");
                this.$emit("form-submited");
            }).catch(error => {
                this.handleFormValidations(error);
            }).finally(() => this.isLoading = false);
        },
        prepareSignUpFormData() {
            const formFields = new FormData();
            const privacyPolicyAccepted = this.signupPrivacy ? 1 : 0;

            formFields.append("first_name", this.firstName);
            formFields.append("last_name", this.lastName);
            formFields.append("address_line_1", this.addressLine1);
            formFields.append("address_line_2", this.addressLine2);
            formFields.append("city", this.city);
            formFields.append("state", this.state);
            formFields.append("zip_code", this.zipCode);
            formFields.append("email", this.email);
            formFields.append("phone_number", this.plainPhoneNumber);
            formFields.append("intended_use", this.intendedUse);
            formFields.append("policy_accepted", privacyPolicyAccepted);
            formFields.append("subscribe_marketing_email", privacyPolicyAccepted);

            return formFields;
        },
        handleFormValidations({ response: error }) {
            const errorKey = error.data.status.message.split(" ")[0];
            // We make sure that the error key is defined as a state in the component
            if (this.$data.hasOwnProperty(_.camelCase(errorKey))) {
                const errorMessage = error.data.status.message.replace(errorKey, errorKey.replace(/_/g, " ")) + ".";
                this.$validator.errors.add({
                    field: _.kebabCase(errorKey),
                    msg: errorMessage
                });
            } else {
                toastr.error("Something appears to have gone wrong while processing your request. " +
                "Please try again or contact us for assistance.", "Error", { timeOut: 12000});
            }
        },
        handleOpen(id) {
            const parentTarget = `#${id}-multiselect-container`;
            $(`${parentTarget} > div > div.multiselect__tags`).append(`<span class='multiselect__fake-placeholder'>${id.replace("-", " ").toUpperCase()}<span>`)
        },
        handleClose() {
            $(`.multiselect__fake-placeholder`).remove();
        }
    }
}
</script>

<style lang="scss">
    @import '~@s/_asset-mixers.scss';

    .pc-rental {
        .sign-up-form {
            background-color: #ececec;
            padding: 75px 0;

            .loading {
                background-color: rgba(0,0,0,0.8);
            }

            h1 {
                text-align: center;
                margin-bottom: 40px;
                margin-top: 0;
            }

            form {
                padding: 0 210px;

                .form-group {
                    margin-bottom: 15px;

                    .form-control {
                        height: 48px;
                        border: 1px solid #e4e4e4;
                        border-radius: 5px;
                        text-transform: uppercase;
                    }
                }

                .checkbox-purple
                    .checkbox-purple
                    input[type="radio"]:checked
                    + label::before,
                .checkbox-purple input[type="checkbox"]:checked + label::before {
                    background-color: $purple;
                    border-color: $purple;
                }

                #signup-privacy:hover {
                    cursor: pointer;
                }

                .multiselect, .bld-multiselect {
                    height: 48px;
                    cursor: pointer;

                    .multiselect__select {
                        height: 48px;
                        padding: 10px 8px;
                    }

                    .multiselect__tags {
                        height: 48px;
                        padding: 13px 40px 0 10px;
                        border-radius: 4px;
                        box-shadow: 0 0 0 2px #afaeaf inset;
                        border: 0;
                        margin-bottom: -1px;

                        .multiselect__placeholder {
                            padding-top: 0;
                        }

                        .multiselect__fake-placeholder {
                            padding-top: 0;
                            color: #adadad;
                            display: inline-block;
                            margin-bottom: 10px;
                        }
                    }

                    .multiselect__option {
                        color: #A6A6A6;
                    }

                    .multiselect__option--highlight {
                        background-color: $purple;
                        color: white;
                    }

                    .multiselect__option--selected,
                    .multiselect__option--highlight {
                        box-shadow: 2px 0 0 0 #afaeaf inset, -2px 0 0 0 #afaeaf inset;
                    }

                    .multiselect__content-wrapper {
                        box-shadow: 0 0 0 2px #afaeaf inset;

                        .multiselect__option {
                            min-height: 32px;
                            padding: 8px 12px;
                        }
                    }

                    &.border-danger {
                        .multiselect__tags {
                            box-shadow: 0 0 0 2px #e63a37 inset !important;
                        }
                    }
                }

                [class^="col-xs"] {
                    padding-left: 5px;
                    padding-right: 5px;
                }

                button {
                    margin-top: 70px;
                }
            }

            @media screen and (max-width: 1200px) {
                form {
                    padding: 0 20px;
                }
            }

            @media screen and (max-width: 992px) {
                form {
                    .btn {
                        width: 100%;
                    }
                }
            }
        }

        .pc-specs,
        .sign-up-form,
        .success-page {
            .btn-green:hover {
                color: initial;
            }
        }

        .border-danger {
            border-color: #e63a37 !important;
        }
    }
</style>
